export type FieldLabelTone =
  | "default"
  | "muted"
  | "admin"
  | "adminCompact"
  | "login";

export const fieldLabelClass: Record<FieldLabelTone, string> = {
  default: "block text-sm font-medium text-gray-800 mb-1.5",
  muted: "block text-sm mb-1.5 text-ns-muted",
  admin: "block text-sm font-medium text-gray-700 mb-2",
  adminCompact: "block text-xs font-medium text-gray-600 mb-1",
  login: "block text-sm font-medium text-gray-700 mb-1",
};

export type InputVariant =
  | "brand"
  | "admin"
  | "adminSm"
  | "adminCompact"
  | "login"
  | "plain";

export const inputVariantClass: Record<InputVariant, string> = {
  brand:
    "w-full rounded-lg px-4 py-2.5 text-sm outline-none border border-ns-soft focus:ring-2 focus:ring-ns-soft-focus/40 focus:border-ns-soft-strong bg-white text-gray-900",
  admin:
    "w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-gray-900",
  adminSm:
    "w-full border border-gray-200 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-gray-900",
  adminCompact:
    "w-full border border-gray-200 rounded-lg px-2 py-1.5 text-xs text-gray-700 bg-white focus:outline-none focus:ring-2 focus:ring-gray-900",
  login:
    "w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500",
  /** No field chrome — use `className` to keep call-site appearance exact. */
  plain: "",
};

export const brandReadOnlyClass =
  "w-full rounded-lg px-4 py-2.5 text-sm outline-none border border-ns-soft focus:ring-2 focus:ring-ns-soft-focus/40 focus:border-ns-soft-strong bg-ns-panel text-gray-700";

export type SelectVariant =
  | "brand"
  | "admin"
  | "native"
  | "nativeCompact"
  | "plain";

export const selectVariantClass: Record<SelectVariant, string> = {
  brand:
    "w-full appearance-none bg-white border border-ns-soft rounded-lg px-4 py-2.5 pr-10 text-sm text-gray-900 outline-none focus:ring-2 focus:ring-ns-soft-focus/40 focus:border-ns-soft-strong",
  admin:
    "w-full appearance-none border border-gray-200 rounded-lg px-3 py-2 pr-8 text-sm text-gray-700 bg-white focus:outline-none focus:ring-2 focus:ring-gray-900",
  native:
    "w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-gray-900 bg-white",
  nativeCompact:
    "w-full border border-gray-200 rounded-lg px-2 py-1.5 text-xs text-gray-700 bg-white focus:outline-none focus:ring-2 focus:ring-gray-900",
  plain: "",
};

export const selectShowsChevron = (variant: SelectVariant) =>
  variant === "brand" || variant === "admin";
